import React from 'react';
import { Link } from 'react-router-dom';
import MarketingShell from '../../components/MarketingShell';
import caseStudies from '../../data/marketing/caseStudies.json';

const published = caseStudies.filter((item) => !item.isDraft);

export default function CaseStudiesIndexPage() {
  return (
    <MarketingShell
      title="Customer stories"
      description="How companies used Upgraded to unlock grants, savings, and operating leverage."
    >
      <ul className="grid gap-4 sm:grid-cols-2">
        {published.map((study) => (
          <li key={study.slug}>
            <Link
              to={`/case-studies/${study.slug}`}
              className="block h-full rounded-xl border border-gray-100 bg-white p-6 hover:border-gray-200 hover:shadow-sm transition-all duration-150"
            >
              <p className="text-sm font-semibold text-gray-900">{study.name}</p>
              {study.excerpt ? <p className="mt-2 text-sm text-gray-600">{study.excerpt}</p> : null}
            </Link>
          </li>
        ))}
      </ul>
    </MarketingShell>
  );
}
